import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {AllOrganizationOrdersContent} from './AllOrganizationOrdersContent';
import reportPayload from './reportPayload';

export const AllOrganizationOrdersReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Organization Orders')}
      description={tt(
        'description',
        'All orders in your organization (all applicable generations).',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={AllOrganizationOrdersContent}
    />
  );
};

export default withHOC(
  withTranslation('report.allOrganizationOrders'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(AllOrganizationOrdersReport);
